import { cn } from '@/lib/cn';

export function Tabs<T extends string>({ tabs, value, onChange }: { tabs: { value: T; label: string; count?: number }[]; value: T; onChange: (v: T) => void }) {
  return (
    <div className="flex w-fit max-w-full gap-1 overflow-x-auto rounded-[9px] bg-[#edf2f7] p-1">
      {tabs.map((t) => (
        <button
          key={t.value}
          onClick={() => onChange(t.value)}
          className={cn(
            'rounded-[7px] px-3 py-1.5 text-[11px] font-semibold whitespace-nowrap transition',
            t.value === value ? 'bg-white text-brand shadow-[0_2px_6px_#d0d9e3]' : 'text-muted hover:text-ink',
          )}
        >
          {t.label}
          {t.count !== undefined && <span className="ms-1.5 rounded bg-danger px-1.5 text-[10px] text-white">{t.count}</span>}
        </button>
      ))}
    </div>
  );
}
